<template>
  <Page :title="pageTitle" id="status-log">
    <o-loading
        :full-page="true"
        :active="isLoading"
        icon="rotate"
        icon-size="large"
    />

    <template v-slot:controls>
      <o-tooltip label="Download Status Logs" variant="secondary">
        <div class="button is-secondary has-margin-top" @click="handleExport">
          <o-icon icon="file-excel" pack="fas" size="large" />
        </div>
      </o-tooltip>
    </template>

    <IndexTable
        :action="statusLogStore.index"
        :columns="defaultTableColumns"
        :display-status-filter="false"
        :display-actions="false"
        :includes="include"
        :items="statusLogStore.data"
        paginated
        pagination-position="both"
        :paginator="paginator"
        :per-page-options="perPageOptions"
        default-items-per-page="2000"
        resource="email-log"
        title="Email Logs"
        :default-sort-by="sortBy"
        default-sort-order="desc"
        v-if="formId"
    />

  </Page>
</template>

<script setup>

  import {useRoute} from "vue-router";

  import Page from "@/components/Page.vue";

  import {
    useAuthStore,
    useFormStore,
    useStatusLogStore,
  } from "@/internal";
  import {computed, ref, watch} from "vue";
  import IndexTable from "@/components/IndexTable.vue";
  import _ from "lodash";

  const formStore = useFormStore();
  const statusLogStore = useStatusLogStore();
  const route = useRoute();
  const isLoading = ref(false);
  const defaultTableColumns = [
    {
      field: 'company_name',
      label: 'Company Name',
      sortable: true,
    },
    {
      field: 'first_name',
      label: 'Contact First Name',
      sortable: true,
    },
    {
      field: 'last_name',
      label: 'Contact Last Name',
      sortable: true,
    },
    {
      field: 'phone_number',
      label: 'Contact Phone',
      sortable: true,
    },
    {
      field: 'email_address',
      label: 'Contact Email',
      sortable: true,
    },
    {
      field: 'email_valid',
      label: 'Email Valid?',
      component: 'ValidInvalidColumn',
      sortable: true,
    },
    {
      field: 'email_status',
      label: 'Email Status',
    },
    {
      field: 'latest_email_sent_on',
      label: 'Latest Sent Date',
      sortable: true,
    },
    {
      field: 'status',
      label: 'Response Status',
    },
  ];
  const paginator = ref({
    perPage: 2000,
  });
  const sortBy = [
    'latest_email_sent_on',
  ];
  const include = [
  ];
  const perPageOptions = [500, 1000, 2000];

  const form = computed(() => {
    return formStore.find(formId.value);
  });

  const formId = computed(() => {
    return route.params.formId || null;
  });

  const pageTitle = computed(() => {
    return "Status Log: " + (form.value ? form.value.name : '');
  });

  function handleExport() {
    if (!formId.value) {
      return;
    }

    isLoading.value = true;

    const payload = {
      params: {
        format: "csv",
        path: "prequal/excel",
        page: {
          offset: paginator.value.current_page,
          limit: statusLogStore.data.length ? statusLogStore.data[0].page_limit : 2000,
        },
      },
    };

    statusLogStore.export(formId.value, `Status Logs - ${form.value.name}`, payload).then((response) => {
    }).catch((error) => {

    }).finally(() => {
      isLoading.value = false;
    });
  }

  watch(() => _.cloneDeep(statusLogStore.data), () => {
    paginator.value = {
      total: statusLogStore.data.length ? statusLogStore.data[0].total_count : 0,
      current_page: statusLogStore.data.length ? statusLogStore.data[0].page_offset + 1 : 1,
    };
  })

</script>

<style lang="scss" scoped>

#status-log {
}

</style>